import React, { useState } from "react";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {
  OVERSIZED_PALLET,
  STANDARD_PALLET,
  MINIMUM_CHARGE,
} from "../../../../../constants/receiving-wizard";
import AssetImage from "src/components/wizard/Item/AssetImage";
import PalletQuantitiesError from "./PalletQuantitiesError";

export default function ConfirmPalletQuantitiesTable({ shipment, shipmentItems, onClose, onNext }) {
  const [error, setError] = useState(false);

  const palletTypeValidation = type => {
    if (type === STANDARD_PALLET || type === OVERSIZED_PALLET) {
      return type;
    }
    return MINIMUM_CHARGE;
  };

  const handleNext = () => {
    const allTypesValid = shipment.totalPieces.every(piece =>
      shipmentItems.some(
        item =>
          palletTypeValidation(item.asset.palletType) === palletTypeValidation(piece.shipment_type)
      )
    );

    if (allTypesValid) {
      onNext();
    } else {
      setError(true);
    }
  };

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Image</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Quantity Received</TableCell>
              <TableCell sx={{ width: 150 }}>Pallet Type</TableCell>
            </TableRow>
          </TableHead>
          {shipmentItems.map(v => (
            <TableRow key={v.id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
              <TableCell component="th" scope="row">
                <AssetImage width={70} height={60} image={v.asset.images[0]?.url} />
              </TableCell>
              <TableCell>{v.asset.description}</TableCell>
              <TableCell>{v.quantity}</TableCell>
              <TableCell>{v.asset.palletType}</TableCell>
            </TableRow>
          ))}
        </Table>
      </TableContainer>
      <Box mt={3} display="flex" justifyContent="flex-end">
        <Button variant="outlined" sx={{ textTransform: "none", mr: 1 }} onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" sx={{ textTransform: "none" }} onClick={handleNext}>
          Validate
        </Button>
      </Box>
      {error && <PalletQuantitiesError onClose={() => setError(false)} />}
    </>
  );
}
